import React, { memo, useMemo } from 'react';
import Chart from './Chart';
import Map from './Map';
import Kpi from './Kpi';
import Table from './Table';
import Empty from '../Widget/Empty';
import { CHART_TYPES, NOT_CHART_TYPES } from '../../constants';

const Charts = memo(({ chartType, config, getImage, googleMapsApiKey, isExpanded }) => {
    const renderChart = useMemo(() => {
        if (!chartType) return null;

        switch (chartType) {
            case NOT_CHART_TYPES.map:
                if (!config?.length) {
                    return <Empty type="empty" />;
                }
                return (
                    <Map data={config} googleMapsApiKey={googleMapsApiKey} getImage={getImage} />
                );
            case NOT_CHART_TYPES.kpi:
                if (!config?.data?.length) {
                    return <Empty type="empty" />;
                }
                return <Kpi data={config} getImage={getImage} />;
            case NOT_CHART_TYPES.table:
                if (!config?.data?.length) {
                    return <Empty type="empty" />;
                }
                return <Table data={config} getImage={getImage} isExpanded={isExpanded} />;
            case CHART_TYPES.bar:
            default:
                if (!config?.datasets?.length) {
                    return <Empty type="empty" />;
                }
                return <Chart type={chartType} data={config} getImage={getImage} />;
        }
    }, [chartType, config, googleMapsApiKey, getImage, isExpanded]);

    return renderChart;
});

export default Charts;
